var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scrollable" }, [
    _c(
      "div",
      { staticClass: "login-screen container mb-3" },
      [
        _c("plan-logo"),
        _vm._v(" "),
        _c("router-view", { attrs: { redirect: _vm.redirect } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }